import { Button, Stack, Step, StepLabel, Stepper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { colors } from "../../../../helpers/colors";

export default function CheckoutProgress(props: { activeStep: number }) {
  const navigate = useNavigate();

  return (
    <Stack
      sx={{ mb: "20px" }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Button
        style={{ backgroundColor: colors.coralRed }}
        variant="contained"
        size="small"
        onClick={() => navigate(-1)}
      >
        back
      </Button>
      <Stepper
        sx={{
          "& .MuiSvgIcon-root.Mui-active": {
            color: colors.coralRed,
          },
          "& .MuiSvgIcon-root.Mui-completed": {
            color: colors.coralRed,
          },
        }}
        activeStep={props.activeStep}
      >
        <Step>
          <StepLabel>Details</StepLabel>
        </Step>
        <Step>
          <StepLabel>Confirmation</StepLabel>
        </Step>
      </Stepper>
    </Stack>
  );
}
